import React from 'react';

interface QuotePageTitleLinkProps {
  title: string;
  symbol: string;
}

/**
 * Renders a page title string, deep-linking the ticker back to the top-level
 * quote page (/quote/[ticker]) only when the title carries a "(AAPL)" /
 * "(NYSE:AAPL)" parenthetical (e.g. the overview title). Newer sub-page titles
 * are plain strings with no parenthetical (e.g. "Apple Inc. Financials"); these
 * render as plain heading text with no link, so the whole heading isn't turned
 * into a hyperlink.
 */
const QuotePageTitleLink: React.FC<QuotePageTitleLinkProps> = ({ title, symbol }) => {
  const escapedSymbol = symbol.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const match = title.match(new RegExp(`(.*\\()([^:)]*:)?(${escapedSymbol})(\\).*)`, 's'));

  if (!match) {
    return <>{title}</>;
  }

  const [, beforeParen, exchangePrefix, ticker, afterParen] = match;
  return (
    <>
      {beforeParen}
      {exchangePrefix ?? ''}
      <a href={`/quote/${symbol}`} className="hover:underline">
        {ticker}
      </a>
      {afterParen}
    </>
  );
};

export default QuotePageTitleLink;
